import React, { Component } from 'react';
import { ButtonToolbar, Button } from 'react-bootstrap';
import CentersDropdownList from '../../centers/DropdownList';
import DateRangePickerButton from '../DateRangePickerButton';
import PaymentCategorySelector from './PaymentCategorySelector';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import QuerySelector from '../savedQueries/QuerySelector';
import moment from 'moment';

class Filter extends Component {
	constructor(props) {
		super(props);
		this.handleSavedQuerySelect = this.handleSavedQuerySelect.bind(this);
		this.handleCenterSelect = this.handleCenterSelect.bind(this);
		this.handleDateRangeSelect = this.handleDateRangeSelect.bind(this);
		this.handleCategoriesSelect = this.handleCategoriesSelect.bind(this);
		this.handleRefresh = this.handleRefresh.bind(this);

		this.state = {
			selectedSavedQuery: null
		};
	}

	getCurrentFilter() {
		const { periodFrom, periodTo, termId, schoolYearId, centerIds, selectedCategories } = this.props;
		return {
			periodFrom,
			periodTo,
			termId,
			schoolYearId,
			centerIds,
			selectedCategories
		};
	}

	handleSavedQuerySelect(savedQuery) {
		this.setState({ selectedSavedQuery: savedQuery });

		const defaultFilter = this.props.defaultFilterValues;

		if (savedQuery) {
			const query = savedQuery.query;

			this.props.onApplyFilter({
				periodFrom: query && query.periodFrom ? moment(query.periodFrom) : defaultFilter.periodFrom,
				periodTo: query && query.periodTo ? moment(query.periodTo) : defaultFilter.periodTo,
				termId: (query && query.termId) ? query.termId : (query && (query.periodFrom || query.selectedCategories)) ? null : defaultFilter.termId,	 // do not use default termId if date range or payment category filter is saved in the query
				schoolYearId: (query && query.schoolYearId) ? query.schoolYearId : (query && (query.periodFrom || query.selectedCategories)) ? null : defaultFilter.schoolYearId,
				centerIds: (query && query.centerIds) || defaultFilter.centerIds,
				selectedCategories: (query && query.selectedCategories) || defaultFilter.selectedCategories
			});
		} else {
			this.props.onApplyFilter(defaultFilter); // reset to default filter
		}
	}

	handleCenterSelect(centerIds) {
		this.props.onApplyFilter({
			...this.getCurrentFilter(),
			centerIds
		});
	}

	handleDateRangeSelect({ periodFrom, periodTo, termId, schoolYearId }) {
		this.props.onApplyFilter({
			...this.getCurrentFilter(),
			periodFrom,
			periodTo,
			termId,
			schoolYearId
		});
	}

	handleCategoriesSelect(selectedCategories) {
		this.props.onApplyFilter({
			...this.getCurrentFilter(),
			selectedCategories
		});
	}

	handleRefresh() {
		this.props.onApplyFilter(this.getCurrentFilter());
	}

	getSavedQueryFilters() {
		const filterValues = this.getCurrentFilter();
		const { t } = this.props;

		return {
			'Centers': {
				label: t('SavedQuery_IncludeCenters'),
				fields: { 'centerIds': filterValues['centerIds'] },
				include: true
			},
			'DateRange': {
				label: t('SavedQuery_IncludeDateRange'),
				fields: {
					'periodFrom': filterValues['periodFrom'],
					'periodTo': filterValues['periodTo'],
					'termId': filterValues['termId'],
					'schoolYearId': filterValues['schoolYearId']
				},
				include: false
			},
			'PaymentCategories': {
				label: t('SavedQuery_IncludePaymentCategories'),
				fields: { 'selectedCategories': filterValues['selectedCategories'] },
				include: false
			}
		};
	}

	render() {
		const { termId, schoolYearId, t } = this.props;
		const buttonClassName = 'sm-btn-lg btn-light-grey';

		const allowCategories = !termId && !schoolYearId;
		const lessonCategory = this.props.paymentCategories ? [1] : [];

		const savedQueryFilters = this.getSavedQueryFilters();

		return <ButtonToolbar className='pull-right buttons-widget'>
			<QuerySelector buttonClassName={buttonClassName} queryType='Sales'
				selectedQuery={this.state.selectedSavedQuery} onSelectQuery={this.handleSavedQuerySelect}
				filters={savedQueryFilters} onSaveQuery={this.handleSaveQuery} />
			<CentersDropdownList render='button' className={buttonClassName} filter={center => !center.isKindergarten} value={this.props.centerIds} onChange={this.handleCenterSelect} emptyLabel={t('Common_AllCenters')} />
			<DateRangePickerButton buttonClassName={buttonClassName} currentCulture={this.props.currentCulture}
			periodFrom={this.props.periodFrom} periodTo={this.props.periodTo}
			termId={this.props.termId} terms={this.props.terms}
			schoolYearId={this.props.schoolYearId} schoolYears={this.props.schoolYears} activeSchoolYearId={this.props.activeSchoolYearId}
			onDateRangeSelect={this.handleDateRangeSelect}
			/>
			{this.props.showPaymentCategories && allowCategories && <PaymentCategorySelector buttonClassName={buttonClassName} categories={this.props.paymentCategories} selectedCategories={this.props.selectedCategories} onChange={this.handleCategoriesSelect} />}
			{this.props.showPaymentCategories && !allowCategories && <PaymentCategorySelector buttonClassName={buttonClassName} categories={this.props.paymentCategories} selectedCategories={lessonCategory} disabled />}
			<Button className={buttonClassName} onClick={this.handleRefresh}><FontAwesomeIcon icon={faRefresh} /></Button>
		</ButtonToolbar>;
	}
}

export default withTranslation()(Filter);